import { render, staticRenderFns } from "./HeaderDentroPasta.vue?vue&type=template&id=16053dee"
import script from "./HeaderDentroPasta.vue?vue&type=script&lang=js"
export * from "./HeaderDentroPasta.vue?vue&type=script&lang=js"
import style0 from "./HeaderDentroPasta.vue?vue&type=style&index=0&id=16053dee&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports